import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../utils/api';
import { syncAuthUserToOnboardingUsers } from '../utils/projectsStore';

const AuthContext = createContext(null);

/** Legacy DB seed name → display as Mugesh */
const normalizeAuthUser = (u) => {
  if (!u) return u;
  const name = (u.name || '').trim();
  if (/^super\s*admin$/i.test(name)) {
    return { ...u, name: 'Mugesh' };
  }
  return u;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem('user');
    if (!raw) return null;
    try {
      return normalizeAuthUser(JSON.parse(raw));
    } catch {
      return null;
    }
  });
  const [token, setToken] = useState(() => localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  const applyUser = (u) => {
    const normalized = normalizeAuthUser(u);
    if (normalized) syncAuthUserToOnboardingUsers(normalized);
    setUser(normalized);
    if (normalized) {
      localStorage.setItem('user', JSON.stringify(normalized));
    }
    return normalized;
  };

  useEffect(() => {
    const verifyToken = async () => {
      if (token) {
        try {
          const res = await API.get('/auth/me');
          applyUser(res.data.user);
        } catch {
          logout();
        }
      }
      setLoading(false);
    };
    verifyToken();
  }, []);

  const login = async (email, password) => {
    const res = await API.post('/auth/login', {
      email: String(email || '').trim(),
      password: String(password || '').trim()
    });
    const { token: t, user: u } = res.data;
    setToken(t);
    localStorage.setItem('token', t);
    return applyUser(u);
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  };

  const updateUser = (updatedUser) => {
    applyUser(updatedUser);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        loading,
        login,
        logout,
        updateUser,
        isAdmin: String(user?.role || '').toLowerCase().includes('admin')
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export default AuthContext;
